import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import { useContext } from "react";
import { BpContext } from "../context/AppContext";
import LocalDataService from "../services/localdata.service";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
function Businesses({ setBp }) {
  const bps = useContext(BpContext);
  const navigate = useNavigate();
  const setDefaultBp = (bp_kapid_id) => {
    LocalDataService.setDefaultBp(bps.kapid_id, bp_kapid_id);
    setBp({ ...bps, selectedBp: bp_kapid_id });
    navigate("/");
  };

  return bps.bp.map((bp) => {
    return (
      <Container>
        <Card style={{ width: "18rem" }} key={bp.bp_kapid_id} className="mt-3">
          <Card.Img
            variant="top"
            src={`https://placehold.co/286x180?text=${bp.bp_name}`}
          />
          <Card.Body>
            <Card.Title>{bp.bp_name}</Card.Title>
            {/* <Card.Text>Address</Card.Text> */}
            <Button
              variant="primary"
              onClick={() => setDefaultBp(bp.bp_kapid_id)}
            >
              Select
            </Button>
          </Card.Body>
        </Card>
      </Container>
    );
  });
}

export default Businesses;
